import { render, staticRenderFns } from "./dailyCollection.vue?vue&type=template&id=0a931118&"
import script from "./dailyCollection.vue?vue&type=script&lang=js&"
export * from "./dailyCollection.vue?vue&type=script&lang=js&"
import style0 from "./dailyCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports